import { css } from 'styled-components';

import { tokens } from '../theme/tokens';

export const focusVisible = css`
	&:focus-visible {
		outline: 2px solid ${tokens.border.focus};
		outline-offset: 2px;
	}
`;
